import React from 'react';
import {driverPicker} from './';
import {UserActions} from '../../actions';
import { connect } from 'react-redux';

class GetDrivers extends React.Component {
    constructor(props) {
        super(props);
        let drivers = this.props.Drivers;
        this.state = {
            drivers,
        };
        if(drivers != []){
            this.props.dispatch(UserActions.get_drivers());
        }
        this.ChangeTabs = this.ChangeTabs.bind(this);

    }
    ChangeTabs(event,data){
        this.props.sendData(data.value);

    }

    render() {
    
        return (
            <div style={{width: '100%'}}>
                {driverPicker.bind(this)(this.props.Drivers)}
            </div>
            
        );
    }

}

function mapStateToProps(state) {
    const {driversExist, Drivers, driversLoading} = state.driverPicker;
    return {
        Drivers,
        driversExist,
        driversLoading,
    };
}
const connectedDrivers = connect(mapStateToProps)(GetDrivers);
export { connectedDrivers as GetDrivers }; 


// WEBPACK FOOTER //
// ./src/components/PanelPages/GetDrivers.jsx